import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Payment from "../pages/payment/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pagar-deuda",
    element: <Payment />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
